import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import enTranslations from './locales/en.json';
import arTranslations from './locales/ar.json';

const resources = {
  en: { translation: enTranslations },
  ar: { translation: arTranslations },
};

i18n.use(initReactI18next).init({
  resources,
  lng: localStorage.getItem('language') || 'ar',
  fallbackLng: ['ar', 'en'],
  parseMissingKeyHandler: (key: string) => {
    const parts = key.split('.');
    const last = parts[parts.length - 1];
    return last ? last.replace(/_/g, ' ') : key;
  },
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
